import { render, staticRenderFns } from "./couponPackageList.vue?vue&type=template&id=08374131&scoped=true&"
import script from "./couponPackageList.vue?vue&type=script&lang=js&"
export * from "./couponPackageList.vue?vue&type=script&lang=js&"
import style0 from "./couponPackageList.vue?vue&type=style&index=0&id=08374131&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08374131",
  null
  
)

export default component.exports